function FormSelect({ country, number }) {
  return (
    <>
      <option value={country}>{`${country} ${number}`}</option>
    </>
  );
}

export default FormSelect;
